module.exports = __webpack_public_path__ + "static/energy_private_3-b843292ec248b6f7fe9debe959e3700b.jpg";